"use client";

import React from "react";
import { BookOpen, Shield, Users } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const wingsData = [{
  title: "SAPMA PEMUDA PANCASILA",
  description: "Satuan Siswa, Pelajar, dan Mahasiswa. Sayap organisasi yang fokus pada pembinaan intelektual, moral, dan kaderisasi di tingkat basis pendidikan serta perguruan tinggi.",
  icon: BookOpen
}, {
  title: "SRIKANDI PEMUDA PANCASILA",
  description: "Sayap perempuan organisasi yang berperan aktif dalam pemberdayaan perempuan, kegiatan sosial kemasyarakatan, perlindungan anak, dan ketahanan keluarga.",
  icon: Users
}, {
  title: "KOTI MAHATIDANA",
  description: "Komando Inti Mahatidana. Pasukan elit dan garda terdepan dalam menjaga marwah organisasi, kedisiplinan kader, serta pengamanan strategis program kerja.",
  icon: Shield
}];
export default function OrganizationalWings() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="bidang" className="bg-background py-16 md:py-24 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6" ref={ref}>
        <div className={`transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="text-center mb-12 md:mb-16 max-w-3xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold font-default text-foreground mb-6 uppercase tracking-tight">
              Perangkat Organisasi
            </h2>
            <div className="w-24 h-1.5 bg-primary mx-auto rounded-md mb-6"></div>
            <p className="text-muted-foreground font-sans text-lg">
              Pilar-pilar penggerak roda organisasi yang memiliki tugas dan fungsi spesifik dalam mewujudkan cita-cita Pemuda Pancasila di berbagai sektor kehidupan bermasyarakat.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {wingsData.map((wing, i) => <div data-index={i} key={i} className="h-full" id={i === 0 ? "sapma" : i === 1 ? "srikandi" : i === 2 ? "koti" : undefined}>
                <Card className="h-full flex flex-col bg-card border-t border-l border-r border-border border-b-4 border-b-primary shadow-md hover:shadow-lg transition-all duration-300 group">
                  <CardHeader className="pb-4">
                    <div className="w-14 h-14 bg-accent rounded-lg flex items-center justify-center mb-6 text-primary group-hover:scale-110 transition-transform duration-300">
                      <wing.icon className="w-7 h-7" />
                    </div>
                    <CardTitle className="text-xl font-bold font-default text-foreground uppercase tracking-tight leading-snug">
                      {wing.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="flex-grow">
                    <p className="text-muted-foreground font-sans leading-relaxed">
                      {wing.description}
                    </p>
                  </CardContent>
                </Card>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}